import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from 'src/app/services/form.service';
import { FormGroup } from '@angular/forms';
import { ModalService } from 'src/app/services/modal.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { AppConstants } from 'src/app/app.constants';
import { ClipboardService } from 'ngx-clipboard';
import * as paillierBigint from 'paillier-bigint';
import { UtilsService } from 'src/app/services/utils.service';
import { LlavesService } from 'src/app/services/llaves.service';

@Component({
  selector: 'app-generadorllavemodal',
  templateUrl: './generadorllavemodal.component.html',
  styleUrls: ['./generadorllavemodal.component.css']
})
export class GeneradorllavemodalComponent implements OnInit {

  @Input() data;
  form: FormGroup;
  submitted: Boolean = false;
  comboLongitudes: any;
  combosList: any;
  usuario: any;
  modo: any;

  constructor(private activeModal: NgbActiveModal, private formService: FormService, private modal: ModalService,
    private alert: NotificacionesService, private utils: UtilsService, private clipboard: ClipboardService, private llavesService: LlavesService) {
    this.combosList = [];
    this.comboLongitudes = AppConstants.LONGITUDES_LLAVES;
    this.combosList.push(this.comboLongitudes);
  }

  ngOnInit(): void {
    this.usuario = this.utils.obtenerDatosUsuario().usuario;
    this.modo = this.data.modo;
    this.form = this.formService.getGeneracionLlavesForm(this.data, this.combosList, this.usuario, this.modo);
  }

  accept() {
    if (this.modo === AppConstants.MODO_VISTA.NUEVO || this.modo === AppConstants.MODO_VISTA.EDITAR) {
      this.submitted = true;
      if (this.form.invalid)
        return;
      this.modal.mostrarModalCargando();
      if (this.form.value.idLlavesCriptograficas > 0)
        this.update(this.form.value);
      else
        this.save(this.form.value);
    } else
      this.close();
  }

  save(llaves) {
    let request = {
      longitud: Number(llaves.longitud.nombre),
      llavePublica: llaves.llavePublica.toString(),
      llavePrivada: llaves.llavePrivada.toString(),
      usuario: llaves.usuario
    };
    this.llavesService.guardar(request).subscribe((data: any) => {
      this.modal.cerrarModalCargando();
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.alert.success(data.mensaje, true);
        this.close();
      }
      else
        this.alert.error(data.mensaje, true);
    }, (error: any) => {
      console.error('Error', error);
      this.modal.cerrarModalCargando();
      this.alert.error('No se pudieron guardar las llaves, intente de nuevo', true);
    });
  }

  update(llaves) {
    let request = {
      idLlavesCriptograficas: llaves.idLlavesCriptograficas,
      longitud: Number(llaves.longitud.nombre),
      llavePublica: llaves.llavePublica.toString(),
      llavePrivada: llaves.llavePrivada.toString(),
      usuario: llaves.usuario
    };
    this.llavesService.actualizar(request).subscribe((data: any) => {
      this.modal.cerrarModalCargando();
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.alert.success(data.mensaje, true);
        this.close();
      }
      else
        this.alert.error(data.mensaje, true);
    }, (error: any) => {
      console.error('Error', error);
      this.modal.cerrarModalCargando();
      this.alert.error('No se pudieron actualizar las llaves, intente de nuevo', true);
    });
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  close() {
    this.activeModal.close();
  }

  copy(texto) {
    this.clipboard.copy(texto.content);
    this.alert.info('Texto copiado al portapeles', true);
  }

  downloadKeyFile(llave, nombreArchivo) {
    let file = new Blob([llave], { type: '.txt' });
    let a = document.createElement("a"),
      url = URL.createObjectURL(file);
    a.href = url;
    a.download = nombreArchivo;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 100);
  }

  async generateKeys() {
    if (this.utils.validarObjeto(this.form.value.longitud)) {
      this.modal.mostrarModalCargando();
      let { publicKey, privateKey } = await paillierBigint.generateRandomKeys(Number(this.form.value.longitud.nombre), true);
      let formValue = this.form.value;
      formValue.llavePublica = publicKey.n;
      formValue.llavePrivada = privateKey.lambda;
      this.form.patchValue(formValue);
      this.modal.cerrarModalCargando();
    } else {
      this.alert.warning('Seleccione el tamaño de la llave', true);
    }
  }

}
